<template>
    <div class="dashboard-icon" :style="{ backgroundColor: backgroundColor, color: color }">
        <i class="material-icons">{{ icon }}</i>
    </div>
</template>

<script>
import { applyTransparency } from '@/utils/helpers';

export default {
    name: 'DashboardIcon',
    props: {
        icon: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: 'var(--primary-color)'
        }
    },
    computed: {
        backgroundColor() {
            const color = applyTransparency(this.color, 0.2)
            console.log(color)
            return color
        }
    }
}
</script>

<style scoped>
.dashboard-icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.dashboard-icon i {
    font-size: 24px;
    width: 24px;
    height: 24px;
}
</style>